<template>
  <section>
    <RolesCards>
    </RolesCards>
  </section>
</template>

<script>
  import RolesCards from './subComponents/RolesCards.vue';

  export default {
    components: {
      RolesCards,
    },
  };
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  section {
    font-size: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    #present-band-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .card-band-styling {
        text-align: center;
        width: 75%;
      }
    }
  }  
</style>